/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ButtonStyle = styled.div`
  margin-top: 2rem;
  .button {
    font-size: 2.2rem;
    background-color: ${(props) =>
      props.outline ? 'transparent' : 'var(--gray-1)'};
    padding: 0.7em 2em;
    border: 2px solid var(--gray-1);
    border-radius: 8px;
    display: inline-block;
    background-color: ${(props) =>
      props.outline ? 'transperant' : 'var(--gray-1)'};
    padding: 0.7em 2em;
    border: 2px solid var(--gray-1);
    border-radius: 8px;
    display: inline-block;
    color: ${(props) => (props.outline ? 'var(--gary-1)' : 'black')};
  }
  @media only screen and (max-width: 768px) {
    .button {
      font-size: 1.8rem;
    }
  }
`;

const urlToDownload =
  'https://drive.google.com/file/d/11LiLhYQ_jFdk_CovRrTqVmTQmKT3SOhf/view?usp=sharing';
export default function ButtonCV({ btnText = 'test', outline = false }) {
  const [download, setDownload] = useState('');
  return (
    <ButtonStyle outline={outline} className="button-wrapper">
      <button
        onClick={() => {
          setDownload(urlToDownload);
        }}
      >
        <a className="button" href={download} target="_blank" rel=" noreferrer">
          {btnText}
        </a>
      </button>
    </ButtonStyle>
  );
}
